module.exports = __webpack_public_path__ + "static/javascript_fullstack_bootcamp-13-8a0894eb2cc74eac00424eeaff64fcfc.jpg";